<template>
    <div class="row">
        <div class="col-lg-12" style="display: flex;">
            <div class="col-md-10" style="padding: 0;">
                <select 
                    class="btn dropdown-toggle btn-primary" 
                    style="width: 100%;"
                    v-model="weatherTime" 
                    @change="setWeatherImg"
                >
                    <option v-for="(data,i) in weatherData" :key="i" :value="data.value">
                        {{ data.text }}
                    </option>
                </select>
            </div>
            <div class="col btn btn-success playBtn" style="padding: 0;" @click="playWeatherImg">
                영상 재생▶
            </div>
        </div>        
        <div class="col-lg-12">
            <img :src="weatherSrc" style="width: 100%;">
        </div>
    </div>    
</template>
<script>
import ImocJS from "@/components/imoc/imoc.js";

export default {
    name: "imoc",
    components: {
        ImocJS
    },
    data() {
        return {
            weatherData: ImocJS.getWeatherDate(),
            weatherTime: "00",
            weatherSrc: "http://www.imocwx.com/cwm/cwmsjp_00.png?0200a"
        }
    },
    mounted() {
        // console.log(this.weatherData);
    },
    methods: {
        setWeatherImg(){
            this.weatherSrc = "http://www.imocwx.com/cwm/cwmsjp_"+ this.weatherTime +".png?0200a";
        },
        playWeatherImg(){
            this.weatherSrc = "http://www.imocwx.com/cwm/cwm_sjp.gif?0400a";
        }
        
    }
};
</script>
<style>
.playBtn{
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
